<section class="hero">
    <div>
        <h1>WATER CHILLER</h1>
        <p>Top-tier Compressors and Chillers for Every Application</p>
        <a class="btn-primary" routerLink="/ourproducts" routerLinkActive="active">Explore Products</a>
    </div>
</section>



<section class="features">
    <h2>Why Choose Us?</h2>
    <div class="feature-grid">
        <div class="feature-item">
            <i class="fas fa-cogs"></i>
            <h3>Advanced Technology</h3>
            <p>Built with the latest engineering to ensure top-tier performance.</p>
        </div>
        <div class="feature-item">
            <i class="fas fa-leaf"></i>
            <h3>Eco-Friendly</h3>
            <p>Energy-efficient and environmentally responsible designs.</p>
        </div>
        <div class="feature-item">
            <i class="fas fa-wrench"></i>
            <h3>Reliable Support</h3>
            <p>24/7 assistance to ensure smooth operation of all products.</p>
        </div>
    </div>
</section>

<!-- Water Chillers Section -->
<section class="water-chillers">
    <h2>Efficient Cooling, Every Time</h2>
    <p>Discover our range of water chillers built for durability and efficiency.</p>
    <div class="chiller-features">
        <div class="chiller-item">
            <i class="fas fa-snowflake"></i>
            <h3>Precision Cooling</h3>
            <p>Accurate and reliable temperature control for industrial needs.</p>
        </div>
        <div class="chiller-item">
            <i class="fas fa-bolt"></i>
            <h3>Energy Saver</h3>
            <p>Optimized for low energy consumption without compromising performance.</p>
        </div>
        <div class="chiller-item">
            <i class="fas fa-tools"></i>
            <h3>Simple Maintenance</h3>
            <p>Designed for easy installation and hassle-free servicing.</p>
        </div>
    </div>
    <a href="mailto:rvproduction2017@gmail.com" class="btn-primary">Request a Quote</a>
</section>


<section class="contact">
    <div class="contact-info">
        <a href="tel:8489359948" class="contact-btn phone-btn">
            <span class="fa fa-phone"></span> Call Now
        </a>
        <a href="mailto:rvproduction2017@gmail.com" class="contact-btn email-btn">
            <span class="fa fa-envelope"></span> Email Us
        </a>
        <a href="https://wa.me/8489359948" target="_blank" class="contact-btn whatsapp-btn">
            <span class="fa fa-whatsapp"></span>WhatsApp
        </a>
    </div>
</section>
